"use client";

import { usePathname } from "next/navigation";

export default function HideOnRoutes({ children, routesToHide }) {
  const pathname = usePathname();
  
  if (routesToHide.includes(pathname)) {
    return null;
  }
  
  return <>{children}</>;
}
